import script from "./newQuestion.vue?vue&type=script&setup=true&lang=ts"
export * from "./newQuestion.vue?vue&type=script&setup=true&lang=ts"

import "./newQuestion.vue?vue&type=style&index=0&id=05714146&lang=less&scoped=true"

import exportComponent from "/Users/neal/www/bonwey/qingtv-back-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05714146"]])

export default __exports__